import { Users } from "../user";
import { Observable } from "rxjs";
import { ApprovalFlow } from "@planard/@core/entities/approvalFlow";

export abstract class ApprovalFlowData {
  abstract update(approval: ApprovalFlow);

  abstract listApprovers(): Observable<Users[]>;
}
